import * as React from 'react';
import MultiSelectModal from '../../../misc/components/queryTable/MultiSelectModal';
import {
    Query,
    QueryCondition,
    QueryFilter,
    Subject,
    SpirometrySessionMetadata,
    QueryOrderDirection
} from "../../../misc/api/apiTypes";
import { useWebPortalLegacyClient } from '../../../misc/api/WebPortalTokenClient';

const SubjectIdFilterQueryCondition = QueryCondition.Equal;
export const SubjectIdHeader = "Subject ID";

interface SubjectFilterProps {
    filterMember: string;
    onApply: (member: string, condition: QueryCondition, values: string[]) => void;
    onClose: () => void;
    query: Query<SpirometrySessionMetadata>;
}

const SubjectIdFilterModal = ({ filterMember, onApply, onClose, query }: SubjectFilterProps): JSX.Element => {

    const GetQueryFilter = (query: Query<SpirometrySessionMetadata>): QueryFilter => {
        return query.Filters.find(filter => filter.Member === filterMember && filter.Condition === SubjectIdFilterQueryCondition);
    }

    const queryFilter = GetQueryFilter(query) || { Values: [] };

    const [values, setValues] = React.useState<any[]>(queryFilter.Values);

    const [allSubjects, setAllSubjects] = React.useState<Subject[]>(null);
    const legacyClient = useWebPortalLegacyClient();

    React.useEffect(() => {
        legacyClient.getSubjects({
            Order: {
                Member: "SubjectNumber",
                Direction: QueryOrderDirection.Ascending,
            }
        }).then(subjectsQ => {
            setAllSubjects(subjectsQ.Data);
        });
    }, []);

    return (<MultiSelectModal header={SubjectIdHeader + ' Filter'}
        isLoading={!allSubjects}
        show={true}
        options={allSubjects}
        valueKey="SubjectNumber"
        labelKey="SubjectNumber"
        values={values}
        onChange={(updatedValues) => {
            setValues(updatedValues.length > 0 ? updatedValues.map(v => v.SubjectNumber) : null);
        }}
        onApply={() => {
            onApply(filterMember, SubjectIdFilterQueryCondition, values);
        }}
        onClear={() => {
            onApply(filterMember, SubjectIdFilterQueryCondition, []);
        }}
        onClose={onClose}
    />)
}

export default SubjectIdFilterModal;
